/**
 * Approved product / range imagery helpers.
 * Never render <img> with empty, null, or whitespace-only src.
 */

export function getPrimaryProductImage(product) {
  if (!product) return null;
  const candidates = [
    ...(Array.isArray(product.images) ? product.images : []),
    product.image,
    product.masterImage,
  ];
  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }
  return null;
}

export function hasApprovedProductImage(product) {
  return Boolean(getPrimaryProductImage(product));
}
